module.exports = __webpack_public_path__ + "img/104_doc_back.cbc16477.svg";